import {AllUserRoles} from 'Authority'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import ProductUsageHistory from 'pages/ProductUsageHistory/ProductUsageHistory'
import useProductManagement from 'features/productManagement/useProductManagement'

export default function ProductUsageHistoryRoute() {
  const {getAllPackageList} = useProductManagement()

  useEffect(() => {
    getAllPackageList()
  }, [])
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_USAGE_HISTORY.path}
          exact
          component={ProductUsageHistory}
        />
        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
